import useGetAllUserLikes from "@/hooks/useGetUserLikes";
import { useFavListingsDispatch } from "@/contexts/fav-listings/favListings.provider";
import actions from "@/contexts/fav-listings/favListings.actions";
import { useEffect } from "react";

export default function UserLikesLoader() {
  const { loading, likesMap, fetchCompleted } = useGetAllUserLikes();
  const dispatch = useFavListingsDispatch();

  useEffect(() => {
    if (!loading && likesMap) {
      dispatch(actions.setUserLikes(likesMap));
    }
  }, [loading, likesMap, dispatch]);

  useEffect(() => {
    dispatch(actions.setFetchLikesCompleted(fetchCompleted));
  }, [fetchCompleted, dispatch]);

  return null;
}
